var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGif),expression:"showGif"}],staticClass:"fullscreen-container"},[_c('img',{staticClass:"center-gif",attrs:{"src":_vm.gifSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }